var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('v-chart',{staticStyle:{"width":"600px","height":"260px"},attrs:{"title":_vm.title,"option":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }